
export const Notifications = {
    Payment_Requested: "Payment_Requested",
    Payment_On_Hold: "Payment_On_Hold",
    Payment_Rejected: "Payment_Rejected",
    High_Priority_Payment: "High_Priority_Payment",
    PROJECT_INVITE_ACCEPTED: "PROJECT_INVITE_ACCEPTED",
    PROJECT_INVITE_DECLINED: "PROJECT_INVITE_DECLINED",
    PAYMENT_COMPLETED: "PAYMENT_COMPLETED",
    PAYMENT_FAILED: "PAYMENT_FAILED",
    COMPLIANCE_COMPLETED: "COMPLIANCE_COMPLETED",
    HONORARIUM_CHANGED: "HONORARIUM_CHANGED",
    TIME_SLOT_SHARED: "TIME_SLOT_SHARED"
}

export const defaultNotificationFormValues = {
    Payment_Requested: false,
    Payment_On_Hold: false,
    Payment_Rejected: false,
    High_Priority_Payment: false,
    PROJECT_INVITE_ACCEPTED: false,
    PROJECT_INVITE_DECLINED: false,
    PAYMENT_COMPLETED: false,
    PAYMENT_FAILED: false,
    COMPLIANCE_COMPLETED: false,
    HONORARIUM_CHANGED: false,
    TIME_SLOT_SHARED: false
}